import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import jwt_decode from 'jwt-decode';
import { Strings } from './Strings';

const useStyles = makeStyles((theme) => ({
  landingOuter: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  landingInner: {
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
    width: 500,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 30,
  },
  landingTable: {
    fontSize: 15,
    fontWeight: 400,
  },
  heading: {
    display: 'flex',
    '& span': {
      marginLeft: 'auto',
    },
  },
}));

export default function LandingPage(props) {
  const [jwtDecode, setJwtDecode] = React.useState(null);

  useEffect(() => {
    let decoded = jwt_decode(window.location.href.split('token=')[1]);
    setJwtDecode(decoded);
    let protocol =
      decoded.redirectUrl.startsWith('https:') ||
      decoded.redirectUrl.startsWith('http:')
        ? ''
        : 'https://';
    let urlToRedirect = `${protocol}${decoded.redirectUrl}`;

    setTimeout(function () {
      window.location.replace(urlToRedirect);
    }, 5000);
  }, []);

  const classes = useStyles();
  return (
    <div className={classes.landingOuter}>
      <div className={classes.landingInner}>
        <h3>
          {`${Strings.WELCOME_TO} ${
            jwtDecode ? jwtDecode.applicationName : ''
          } app`}
        </h3>
        <br />
        <table className={classes.landingTable}>
          <tr>
            <td className={classes.heading}>
              {Strings.NAME}
              <span>:</span>
            </td>
            <td>{jwtDecode ? jwtDecode.name : ''}</td>
          </tr>
          <tr>
            <td className={classes.heading}>
              {Strings.EMAIL}
              <span>:</span>
            </td>
            <td>{jwtDecode ? jwtDecode.email : ''}</td>
          </tr>
          <tr>
            <td>
              {Strings.PHONENO} <span>:</span>
            </td>
            <td>{jwtDecode ? jwtDecode.phone : ''}</td>
          </tr>
        </table>
      </div>
    </div>
  );
}
